// extracted by mini-css-extract-plugin
module.exports = {"TextAndImage":"TextAndImage_TextAndImage__1OvmI","Text":"TextAndImage_Text__2AhrJ","Image":"TextAndImage_Image__10fd5"};